// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RgWW","badges":"styles_badges__p1Vkj"};